import React from 'react';

import {
  AuditReviewPageRoute,
  codingVisitsApi,
  VisitPageRoute,
} from './lib/components/coding-list/visit-page';
import { CodingRoute } from './lib/components/coding-tool/coding-route';
import { DocumentsLink } from './lib/components/common/navigation';
import { OrgSelectDialog } from './lib/components/common/organization-select';
import { CodeBooks } from './lib/components/trucode/code-books';

import { history, Router } from './lib/core/router';
import { TruCode } from './lib/core/trucode';
import { loadVisitById } from './lib/core/visit-context';
import { workflows } from './lib/core/workflow-api';
import { WorkflowsDialogue } from './lib/core/workflows';

import { Route, Routes, Navigate } from 'react-router';
import { AppContext } from './lib/common/app-context';
import { SecureRoute } from './lib/common/secure-route';
import { auth, getOrgUrlParams } from './lib/core';
import './App.css';
import { EmptyLoadingPage } from './lib/components/common/presentation';
import { DocumentsRoute2 } from './lib/core/document-viewer/document-components';
import { userProfileApi } from './lib/api/user-profile-api';

window.onload = () => {
  // A value of 1 indicates a classic 96 DPI (76 DPI on some platforms) display, while a value of 2 is expected for HiDPI/Retina displays
  console.log('window.devicePixelRatio', window.devicePixelRatio);

  if (window.devicePixelRatio === 2 && (navigator.userAgent.indexOf('Win') !== -1)) {
    (document.body.style as any).zoom = 0.9;
  } else {
    (document.body.style as any).zoom = 1;
  }
};

const params = getOrgUrlParams();
const { organizationCode, locationCode, departmentCode, workflow, visitId, activity, worksheetId } =
  params || {};
const isAuditReview = window.location.href.indexOf('/audit') > -1;

function loadWorkflow(workflow: string, complete?: () => void) {
  if (organizationCode) {
    codingVisitsApi.org
      .getState()
      .setSelectionByCode(organizationCode, locationCode, departmentCode);
  }

  const args: any = {
    workflow,
    location: locationCode,
    department: departmentCode || 'ED', // TODO allow department change
    activity: activity || 'CODING', // TODO manage audit request
  };
  if (visitId) {
    workflows.actions.load(args).then(() => complete && complete());
  } else {
    setTimeout(() => {
      workflows.actions.load(args).then(() => complete && complete());
    }, 500);
  }
}

async function init() {
  await codingVisitsApi.org.getState().loadOrganizations(null);
  const orgs = codingVisitsApi.org.getState().organizations;
  if (!orgs.length) {
    alert('No organizations loaded');
  }


  auth.signedIn = userProfileApi.data.getState().user;
  window.console.info('auth.signedIn ', auth.signedIn );

  if (visitId) {
    loadWorkflow('auditStd', () => {
      loadVisitById(params.visitId, true, worksheetId);
    });
  } else if (organizationCode) {
    loadWorkflow(isAuditReview ? 'auditStd' : workflow );
  } else {
    codingVisitsApi.org.setState({ promptOrg: true });
  }

  if (window.location.pathname.replace('null', '').length < 2) {
    history.push(isAuditReview ? '/audit' : '/list');
  }
}

const debug = new URLSearchParams(window.location.search).has('debug');

function signOut() {
  auth.signOut();
}

function onOrgSelectComplete() {
  if (workflow && !organizationCode) {
    const { organization, location, department } =
      codingVisitsApi.org.getState().selection;

    if (organization && location && department) {
      const args = {
        workflow,
        location: location.code,
        department: department?.code || 'ED', // TODO allow department change
        activity: 'CODING', // TODO manage audit request
      };
      workflows.actions.load(args);
    }
  }
}
export function AppLegacy() {
  return (
    <AppContext
      idleTimeout
      onAuthorized={() => !debug && init()}
      onSignOut={null}
    >
      <Router>
        <Routes>
          <Route
            path="/list"
            element={
              <SecureRoute exact path="/list">
                <WorkflowsDialogue />
                <OrgSelectDialog
                  api={codingVisitsApi.org}
                  onComplete={onOrgSelectComplete}
                />
                <VisitPageRoute signOut={signOut} />
              </SecureRoute>
            }
          />

          <Route
            path="/audit"
            element={
              <SecureRoute exact path="/audit">
                <WorkflowsDialogue />
                <AuditReviewPageRoute signOut={signOut} />
              </SecureRoute>
            }
          />

          <Route
            path="/documents"
            element={
              <SecureRoute exact path="/documents">
                <DocumentsRoute2 />
              </SecureRoute>
            }
          />

          <Route
            path="/tool"
            element={
              <SecureRoute exact path="/tool" noRedirect={true}>
                <WorkflowsDialogue />
                <TruCode />
                <CodingRoute />
              </SecureRoute>
            }
          />

          <Route
            path="/search"
            element={
              <SecureRoute exact path="/search">
                <CodeBooks />
              </SecureRoute>
            }
          />

          <Route path="/visit" element={<EmptyLoadingPage/>} />
          <Route path="/" element={<Navigate replace to="/list" />} />
        </Routes>
      </Router>
      <DocumentsLink hide={true} />
    </AppContext>
  );
}

